// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-pdf .summary-graph .summary-graph-wrapper .avg-score {\n  display: none;\n}\n.custom-pdf .summary-graph .summary-graph-split .score-overview {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
